<era-pane>
  <h5 class="small-caps"
      i18n>Diagnostic Submission</h5>
  <form [formGroup]="diagnosticSubmissionForm"
        (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <div class="form-check form-switch">
        <input type="checkbox"
               class="form-check-input rounded-3"
               role="switch"
               formControlName="diagnosticSubmissionEnabled"
               id="diagnosticSubmissionEnabled" />
        <label class="form-check-label"
               for="diagnosticSubmissionEnabled">Turn Diagnostic Submission {{ (diagnosticSubmissionEnabled.valueChanges
          | async) ? 'On' : 'Off' }}</label>
        <small class="form-text text-muted">Sets the user preference of diagnostic submission.</small>
      </div>
    </div>
    <button class="btn btn-primary"
            type="submit"
            [disabled]="!diagnosticSubmissionForm.valid">Submit</button>
  </form>
</era-pane>